import { SliceComponentProps } from '@prismicio/react';
import React from 'react';
import SEO from '../SEO';

const SEOSlice = (props: SEOSliceType) => {
  const data = props.slice.primary;
  
  return (
    <SEO
      title={data.metaTitle || data.meta_title?.text || data.meta_title1?.text}
      description={
        data.metaDescription ||
        data.meta_description?.text ||
        data.meta_description1?.text
      }
    />
  );
};

export type SEOSliceType = SliceComponentProps<{
  id: string;
  primary: {
    metaTitle?: string;
    metaDescription?: string;
    meta_description?: { text: string };
    meta_description1?: { text: string };
    meta_title?: { text: string };
    meta_title1?: { text: string };
    path?: string;
  };
  slice_type: string;
}>;

export default SEOSlice;
